import _ from 'lodash';
import CreationMethodEnum from '@/Api/Deal/CreationMethodEnum';
import IDeal, { IDealErrors } from '@/Api/Deal/IDeal';
import IDealProperty from '@/Api/Deal/IDealProperty';
import IDealQuote from '@/Api/Deal/IDealQuote';
import { IGlobalState } from '@/reducer';
import { IDictionary } from '@/utilities/IDictionary';
import IAddressSearchResult from '@/Api/AddressSearch/IAddressSearchResult';

function hydrateDeal(state: IGlobalState, deal: IDeal): IDeal {
    const cloneDeal: IDeal = { ...deal };
    cloneDeal.properties = propertiesSelector(state);

    return cloneDeal;
}

export function currentDealAutoQuoteSelector(state: IGlobalState, dealUuid: string): IDealQuote {
    if (!dealUuid || !state.lead.dealQuoteUuids || !state.lead.dealQuoteUuids[dealUuid] || state.lead.dealQuoteUuids[dealUuid].length !== 1) {
        return null;
    }

    const quote: IDealQuote = state.lead.quotes[state.lead.dealQuoteUuids[dealUuid][0]];

    return quote.creationMethod === CreationMethodEnum.Auto ? quote : null;
}

export function dealSelector(state: IGlobalState): IDeal {
    return state.lead.deal && hydrateDeal(state, state.lead.deal);
}

export function dealsSelector(state: IGlobalState): IDictionary<IDeal> {
    if (!state.lead.dealsListed || !state.lead.deals) {
        return null;
    }

    const deals: IDictionary<IDeal> = {};

    _.forEach(state.lead.deals, (deal: IDeal) => {
        deals[deal.uuid] = hydrateDeal(state, deal);
    });

    return deals;
}

export function errorsSelector(state: IGlobalState): IDealErrors {
    return state.lead.errors;
}

export function propertiesSelector(state: IGlobalState): IDealProperty[] {
    return _.values(state.lead.properties);
}

export function propertySelector(state: IGlobalState, uuid: string): IDealProperty {
    return state.lead.properties[uuid];
}

export function savingSelector(state: IGlobalState): boolean {
    return state.lead.saving;
}

export function dealPropertyAddressSearchResultsSelector(state: IGlobalState): IAddressSearchResult[] {
    return state.lead.addressSearchResults;
}

export function dealPropertyAddressSearchResultsLoadingSelector(state: IGlobalState): boolean {
    return state.lead.addressSearchResultsLoading;
}

export function dealPropertyGnafAddressDetailLoadingSelector(state: IGlobalState): boolean {
    return state.lead.gnafAddressDetailLoading;
}
